import { getAllShippers, getShippersWithTransports } from "@/features/shippers/api";

export const EVENT = {
  SHIPPERS_REQUESTED: "SHIPPERS_REQUESTED",
  SHIPPERS_WITH_TRANSPORTS_REQUESTED: "SHIPPERS_WITH_TRANSPORTS_REQUESTED",
  REQUEST_SHIPPERS_SUCCEEDED: "REQUEST_SHIPPERS_SUCCEEDED",
  REQUEST_SHIPPERS_WITH_TRANSPORTS_FAILED: "REQUEST_SHIPPERS_WITH_TRANSPORTS_FAILED",
  REQUEST_SHIPPERS_FAILED: "REQUEST_SHIPPERS_FAILED",
  REQUEST_SHIPPERS_WITH_TRANSPORTS_SUCCEEDED: "REQUEST_SHIPPERS_WITH_TRANSPORTS_SUCCEEDED",
};

export const defaultState = () => ({
  shippers: [],
  shippersWithTransports: [],
  fetchingShippers: false,
  fetchingShippersWithTransports: false,
  fetchingShippersFailedError: null, 
  fetchingShippersWithTransportsFailedError: null,
});

export const mutations = {
  [EVENT.SHIPPERS_REQUESTED](state) {
    state.fetchShippers = true;
  },

  [EVENT.REQUEST_SHIPPERS_SUCCEEDED](state, response) {
    state.fetchingShippersFailedError = null;
    state.shippers = response;
    state.fetchingShippers = false;
  },

  [EVENT.REQUEST_SHIPPERS_FAILED](state, error) {
    state.fetchShippers = false;
    state.fetchingShippersFailedError = error;
  },

  [EVENT.SHIPPERS_WITH_TRANSPORTS_REQUESTED](state) {
    state.fetchingShippersWithTransports = true;
  },

  [EVENT.REQUEST_SHIPPERS_WITH_TRANSPORTS_SUCCEEDED](state, response) {
    state.fetchingShippersWithTransportsFailedError = null;
    state.shippersWithTransports = response;
    state.fetchingShippersWithTransports = false;
  },

  [EVENT.REQUEST_SHIPPERS_WITH_TRANSPORTS_FAILED](state, error) {
    state.fetchingShippersWithTransports = false;
    state.fetchingShippersWithTransportsFailedError = error;
  },
};

export const actions = ({ getShippersWithTransports }) => ({
   async fetch({ commit }) {
    commit(EVENT.SHIPPERS_REQUESTED);
    try {
      const response = await getAllShippers();
      commit(EVENT.REQUEST_SHIPPERS_SUCCEEDED, response);
    } catch (error) {
      commit(EVENT.REQUEST_SHIPPERS_FAILED, error);
    }
  },

  async fetchShippersWithTransports({ commit }) {
    commit(EVENT.SHIPPERS_WITH_TRANSPORTS_REQUESTED);
    try {
      const response = await getShippersWithTransports();
      commit(EVENT.REQUEST_SHIPPERS_WITH_TRANSPORTS_SUCCEEDED, response);
    } catch (error) {
      commit(EVENT.REQUEST_SHIPPERS_WITH_TRANSPORTS_FAILED, error);
    }
  },
});

/**
 * Builds a store module for storing transport shippers.
 * @returns {Object} - A Vuex module.
 */
export function buildShippersModule() {
  return {
    namespaced: true,

    state: defaultState(),

    mutations,

    actions: actions({ getAllShippers, getShippersWithTransports }),

    getters: {},
  };
}
